export default "__VITE_ASSET__Cd9eTUmk__"